import {DataModificationsHeader} from 'audit/DataModifications';
import {MixtureGroup} from 'notebook/integrations/registry/MixtureNoteLinkedGroupAdapter';
import {RegistrationDAOResponseBase} from 'notebook/integrations/registry/RegistrationActionUtil';
import {clientId} from 'notebook/store/VersioningConstants';
import {ActionFunctionContext} from 'notebook/structured-tables/action-functions/ActionFunctionContext';
import {TableSubmissionDiffs} from 'notebook/structured-tables/util/datamods/getStructuredTableCellDiffOnSubmission';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import * as net from 'util/Net';

const enum ACTION_FUNCTIONS {
  MIXTURE_PREP_SUBMIT = 'mixture-prep-submit',
}

function _runAction<ActionResponse>(
  entryId: string,
  provenanceUuid: string,
  actionName: string,
  evaluatedTableMap: {[tableName: string]: Array<Array<EvaluatedCell>>},
  actionFunctionContext: ActionFunctionContext,
  tableSubmissionDiffs?: TableSubmissionDiffs,
  extraParams?: object,
  dataModsHeader?: DataModificationsHeader
): Promise<ActionResponse> {
  return net.postJSONPromise({
    url: `/1/api/entries/${entryId}/note-linked-groups/${provenanceUuid}/action/${actionName}`,
    data: {
      evaluatedTableMap,
      tableSubmissionDiffs,
      actionFunctionContext,
      clientId,
      ...extraParams,
    },
    extraHeaders: dataModsHeader,
  });
}

export interface MixtureGroupResponse extends RegistrationDAOResponseBase {}

export function submitMixtureGroup(
  entryId: string,
  mixtureGroup: MixtureGroup,
  evaluatedTableMap: {[tableName: string]: Array<Array<EvaluatedCell>>},
  actionFunctionContext: ActionFunctionContext,
  tableSubmissionDiffs?: TableSubmissionDiffs,
  extraParams: {allowMerging: boolean} = {allowMerging: false},
  dataModsHeader?: DataModificationsHeader
): Promise<MixtureGroupResponse> {
  return _runAction<MixtureGroupResponse>(
    entryId,
    mixtureGroup.provenanceUuid,
    ACTION_FUNCTIONS.MIXTURE_PREP_SUBMIT,
    evaluatedTableMap,
    actionFunctionContext,
    tableSubmissionDiffs,
    extraParams,
    dataModsHeader
  );
}
